import React from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { COMPANY, NAV_LINKS } from "@/lib/site";

const preventFocusJump = (event) => event.preventDefault();

export const MobileNav = ({ open, onOpenChange, onSelect }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetTrigger asChild>
      <Button
        variant="outline"
        size="icon"
        data-testid="header-mobile-menu-button"
        className="lg:hidden"
        aria-label="Open menu"
      >
        <Menu className="h-5 w-5 text-[#0b1d3a]" />
      </Button>
    </SheetTrigger>

    <SheetContent
      side="right"
      className="w-[86%] bg-white sm:w-80"
      onCloseAutoFocus={preventFocusJump}
    >
      <SheetTitle className="sr-only">Navigation menu</SheetTitle>
      <SheetDescription className="sr-only">
        Jump to a section of the Moruya Travel Solutions corporate site.
      </SheetDescription>

      <div className="mt-2 flex items-center justify-between">
        <img
          src={COMPANY.logo}
          alt={`${COMPANY.name} logo`}
          className="h-24 w-auto object-contain"
        />
      </div>

      <nav aria-label="Mobile navigation" className="mt-8 flex flex-col gap-1">
        {NAV_LINKS.map((link) => (
          <button
            key={link.id}
            type="button"
            data-testid={`mobile-nav-${link.id}-link`}
            onClick={() => onSelect(link.id)}
            className="rounded-lg px-3 py-3 text-left text-base font-medium text-[#0b1d3a] transition-colors hover:bg-slate-50"
          >
            {link.label}
          </button>
        ))}
      </nav>
    </SheetContent>
  </Sheet>
);
